import React from 'react'
import { Img } from './img'
import style from "./Home.module.css";



export const Toppage = () => {
  return (
    <div>
{/*  poster="https://cdn-images.cure.fit/www-curefit-com/image/upload/c_fill,w_1400,q_auto:eco,dpr_2,f_auto,fl_progressive/image/test/we-are-cult-logo/promo-video-poster.jpg" */}
<div className={style.video_frame}>
       

          <video
          id={style.v_bag}
          autoPlay
          loop
          muted
          preload="auto"
          poster="https://cdn-images.cure.fit/www-curefit-com/image/upload/c_fill,w_1400,q_auto:eco,dpr_2,f_auto,fl_progressive/image/test/we-are-cult-logo/promo-video-poster.jpg"
          src="https://cdn-images.cure.fit/www-curefit-com/video/upload/c_fill,w_1400,ar_1.77,q_auto:eco,dpr_2,vc_auto,f_auto/video/test/we-are-cult-web.mp4"
        ></video>
       
        <div className={style.contant}>
                  <div className={style.left}>
                    <svg
                      width="998"
                      height="399"
                      viewBox="0 0 998 399"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        id="Path 5"
                        opacity="0.658748"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M998 398.116C998 398.116 901.882 207.384 619.882 240.987C337.882 274.59 85.3818 0.0878906 85.3818 0.0878906L0.881775 111.308C0.881775 111.308 312.882 361.673 605.882 291.154C898.882 220.636 993.5 398.116 993.5 398.116H998Z"
                        fill="url(#paint0_linear_6391_14873)"
                      ></path>

                      <defs>
                        <linearGradient
                          id="paint0_linear_6391_14873"
                          x1="76.9999"
                          y1="123.5"
                          x2="418.867"
                          y2="699.423"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#62B1F2" stop-opacity="0"></stop>
                          <stop
                            offset="0.582702"
                            stop-color="#2BF2FF"
                            stop-opacity="0.74"
                          ></stop>
                        </linearGradient>
                      </defs>
                    </svg>

                    <svg
                      width="1033"
                      height="256"
                      viewBox="0 0 1033 256"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        id="Path 6"
                        opacity="0.658748"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1032.26 105.178C1032.26 105.178 831.789 -99.4979 605.32 63.0676C378.851 225.633 15.1793 107.411 15.1793 107.411L0.750166 243.722C0.750166 243.722 403.2 312.882 619.696 113.14C836.191 -86.6017 1029.23 106.835 1029.23 106.835L1032.26 105.178Z"
                        fill="url(#paint0_linear_6391_14874)"
                      ></path>

                      <defs>
                        <linearGradient
                          id="paint0_linear_6391_14874"
                          x1="-27"
                          y1="140"
                          x2="768.964"
                          y2="587.997"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#111D27" stop-opacity="0"></stop>
                          <stop offset="1" stop-color="#FBD94C"></stop>
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
          
               <div className={style.imge}>
               <Img />
               </div>
          

                <div className={style.right}>
                  <svg
                    width="906"
                    height="569"
                    viewBox="0 0 906 569"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      id="Path 3"
                      opacity="0.815929"
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0.541494 567.256C0.541494 567.256 288.184 599.186 412 357.019C535.815 114.851 905.7 128.198 905.7 128.198L853.178 0.542129C853.178 0.542129 460.098 56.1967 363 327.202C265.902 598.207 2.44773 564.478 2.44773 564.478L0.541494 567.256Z"
                      fill="url(#paint0_linear_6391_14875)"
                    ></path>

                    <defs>
                      <linearGradient
                        id="paint0_linear_6391_14875"
                        x1="896.553"
                        y1="577.97"
                        x2="66.1909"
                        y2="486.524"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#111D27" stop-opacity="0"></stop>
                        <stop offset="1" stop-color="#EC4ED1"></stop>
                      </linearGradient>
                    </defs>
                  </svg>

                  <svg
                    width="1027"
                    height="281"
                    viewBox="0 0 1027 281"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      id="Path 4"
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0.499904 107.489C0.499904 107.489 79.4999 216.344 436 89.0315C792.5 -38.2805 965.255 280.41 965.255 280.41L1026.54 215.707C1026.54 215.707 708 -124.891 397 51.6425C85.9999 228.176 47.9999 89.0315 47.9999 89.0315L0.499904 107.489Z"
                      fill="url(#paint0_linear_6391_14872)"
                    ></path>

                    <defs>
                      <linearGradient
                        id="paint0_linear_6391_14872"
                        x1="604.206"
                        y1="548.044"
                        x2="260.146"
                        y2="17.1812"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#111D27" stop-opacity="0"></stop>
                        <stop offset="1" stop-color="#FBD94C"></stop>
                      </linearGradient>
                    </defs>
                  </svg>


                  <button className={style.Button}> EXPLORE CARE&FIT</button>
                </div>
        </div>
      </div>


    </div>
  )
}
